import { useTranslation } from 'react-i18next';

export const useChartDataWithTranslations = (
  data: { label: string; value: number }[],
  translationFn: (label: string) => string,
) => {
  const { t } = useTranslation();

  return data?.map(item => ({
    ...item,
    label: t(
      // @ts-ignore
      translationFn(item.label),
    ) as string,
  }));
};
